import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=39f43ae7&scoped=true&"
import script from "./Arrow.vue?vue&type=script&lang=ts&"
export * from "./Arrow.vue?vue&type=script&lang=ts&"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=39f43ae7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f43ae7",
  null
  
)

export default component.exports